export default __webpack_public_path__ + "static/media/background3.9d4c8ca1.png";